<template>
    <div>
        <a :class="{ noHover: !enableDropdown }">
            <header
                class="advanced-filter-text uk-text-large"
                :class="{ activated: activated, deactivated: !activated }"
            >
                {{ text }}
            </header>
        </a>
        <div
            v-if="enableDropdown"
            uk-dropdown="pos: bottom-left"
        >
            <ul class="uk-nav uk-dropdown-nav">
                <li
                    v-if="header"
                    class="uk-nav-header"
                >
                    {{ header }}
                </li>
                <li
                    v-for="option in options"
                    :key="option.value"
                    :class="{ 'uk-active': isOptionInSelectedValues(option) }"
                >
                    <a @click="updateFilter(option)">
                        <span
                            v-if="isOptionInSelectedValues(option)"
                            uk-icon="icon: check"
                        />
                        {{ option.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        noSelectedText: {
            type: String,
            default: () => {
                return "any";
            }
        },
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        activated: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        sentenceCase: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        lowerCase: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        header: {
            type: String,
            default: () => {
                return null;
            }
        },
        enableDropdown: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
    },
    data() {
        return {
            buffer: []
        };
    },
    computed: {
        text() {
            let result = this.getFromObjectArrayByKey(this.value, 'name').join(", ");
            if (result.length === 0) {
                result = this.noSelectedText;
            }

            if (this.lowerCase) {
                result = result.toLowerCase();
            }

            if (this.sentenceCase) {
                result = result.toLowerCase();
                result = result.charAt(0).toUpperCase() + result.substring(1);
            }

            return result;
        }
    },
    methods: {
        updateFilter(option) {
            this.buffer = [option];
            this.$emit('input', this.buffer);
        },
        isOptionInSelectedValues(option) {
            return this.value.filter(function (selected) {
                return selected.value === option.value;
            }).length > 0;
        },
        getFromObjectArrayByKey(objectArray, key) {
            return objectArray.map(object => object[key]);
        }
    }
}
</script>


<style lang="scss">

@import "../../scss/variables.scss";

.advanced-filter-text {
    text-decoration: underline;

    &.activated {
        color: $global-color;
    }

    &.deactivated {
        color: $colour-medium-grey;
    }
}

a.noHover {
    pointer-events: none;
}
</style>